import React, { Fragment } from 'react';
import styled from 'styled-components';
import { FontFamily } from '@zocdoc/components/src/typography';
import breakpoint from '@zocdoc/components/src/grid/mixins/breakpoint';

const COMMON_PHRASE = 'Book Top ';

const SalpHeader = ({ children: title }) => (
    <StyledBlock>
        {title.startsWith(COMMON_PHRASE)
            ? (
                <Fragment>
                    <StyledSpan>{COMMON_PHRASE}</StyledSpan>
                    <StyledH1>{title.substring(COMMON_PHRASE.length)}</StyledH1>
                </Fragment>
            ) : <StyledH1>{title}</StyledH1>
        }
    </StyledBlock>
);

const headerStyle = `
    display: inline;
    font: 24px/32px ${FontFamily.SharpSansBold};
    font-weight: bold;
    
    ${breakpoint.small} {
        font-size: 32px;
        line-height: 40px;
    }
    
    ${breakpoint.large} {
        font-size: 40px;
        line-height: 48px;
    }
`;

const StyledH1 = styled.h1`
    ${headerStyle}
`;

const StyledSpan = styled.span`
    ${headerStyle}
`;

const StyledBlock = styled.div`
    margin-bottom: 13px;
    ${breakpoint.small} {
        margin-bottom: 24px;
    }
`;

export default SalpHeader;
